/* 🤖 this file was generated by svg-to-ts */
export const emperorIconCheckInCircle: {
  name: 'check_in_circle';
  data: string;
} = {
  name: 'check_in_circle',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="7.49 11.76 73.21 68.9"><path d="M40.4883 80.6665C22.2943 80.6665 7.48828 65.8642 7.48828 47.6665C7.48828 29.4688 22.2943 14.6665 40.4883 14.6665V21.9998C26.3349 21.9998 14.8216 33.5132 14.8216 47.6665C14.8216 61.8198 26.3349 73.3332 40.4883 73.3332C54.6416 73.3332 66.1549 61.8198 66.1549 47.6665H73.4883C73.4883 65.8642 58.6823 80.6665 40.4883 80.6665Z"/><path d="M44.4914 61.82L26.2461 43.5747L32.7251 37.092L43.8131 48.18L73.6048 11.7627L80.6998 17.5707L44.4914 61.82Z"/></svg>`,
};
